import {VacatureService} from '../../services/vacature.service';
import {Component, computed, inject, signal} from '@angular/core';
import {LoadingVacatureInfoComponent} from '../loading-vacature-info/loading-vacature-info.component';
import {VacatureInfoComponent} from '../vacature-info/vacature-info.component';
import {form, FormField} from '@angular/forms/signals';

@Component({
  selector: 'mvw-mijn-vacatures-page',
  imports: [
    LoadingVacatureInfoComponent,
    VacatureInfoComponent,
    FormField
  ],
  templateUrl: './mijn-vacatures-page.component.html'
})
export class MijnVacaturesPageComponent {

  private readonly vacatureService = inject(VacatureService);

  readonly trefwoordModel = signal({trefwoord: ''});
  readonly trefwoordForm = form(this.trefwoordModel);

  readonly vacatureInfo = this.vacatureService.vacatureInfo;

  readonly trefwoordUrl = computed(() => {
    const trefwoord = this.trefwoordModel().trefwoord.trim();
    const urlZonderTrefwoord = '/vac/werkgevers/mijnjobs?showZoekDiv=true';
    const urlMetTrefwoord = '/vac/werkgevers/mijnjobs?showZoekDiv=true&trefwoord=';
    return trefwoord.length === 0 ? urlZonderTrefwoord : urlMetTrefwoord + encodeURIComponent(trefwoord);
  });

  triggerTrefwoordLink(): void {
    const link = document.getElementById('trefwoordLink');
    link?.click();
  }

}
